import { ICareProvider } from "../models/ICareProvider";
import { IGeneralDentalReferral } from "../models/IGeneralDentalReferral";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class GeneralDentalReferralApi extends ApiClient {

    getGeneralDentalReferral(generalDentalReferralId: number, refresh: boolean, success: (data: IGeneralDentalReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IGeneralDentalReferral>(`${Utils.LIB_API_BASE_URL}/generalDentalReferral/${generalDentalReferralId}?refresh=${refresh}`, success, error, final);
    }

    getGeneralDentalReferralReferrer(success: (data: ICareProvider) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider>(`${Utils.LIB_API_BASE_URL}/generalDentalReferral/referrer`, success, error, final);
    }

    getGeneralDentalReferralRecipient(patientId: number, success: (data: ICareProvider) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider>(`${Utils.LIB_API_BASE_URL}/generalDentalReferral/recipient/${patientId}`, success, error, final);
    }

    downloadGeneralDentalReferralAttachment(generalDentalReferralAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/generalDentalReferral/file/${generalDentalReferralAttachmentId}`, fileName ?? "", undefined, error);
    }
}